<template>
  <div class="product">
    <h2>商品信息</h2>
    <div class="normal">商品标题：
      <div class="inputBox">
        <el-input v-model="title"></el-input>
      </div>
    </div>
    <div class="normal">所属店铺：
      <el-select v-model="shop_id" filterable placeholder="选择店铺" default-first-option
            :remote-method="searchShop" remote clearable>
        <el-option v-for="item in matchShops" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="normal">优惠券金额：
      <div class="inputBox">
        <el-input v-model="coupon_val" type="number"></el-input>
      </div>
    </div>
    <div class="normal">一级类目：
      <el-select v-model="cat_name" filterable placeholder="选择类目" default-first-option>
        <el-option v-for="item in catNames" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </div>

    <div class="line">----------------封面图----------------</div>
    <div class="normal">
      <input type="file" @change="chooseImage" id="cover_image">
    </div>
    <div class="imageBoxMini" v-if="cover_image">
      <img :src="cover_image" preview="3" preview-text="封面图">
    </div>

    <div class="line">----------------详情头图----------------</div>
    <div class="normal">
      <input type="file" @change="chooseImage" id="top_images">
    </div>
    <div style="display: inline-block;">
      <div class="imageBox">
        <div v-for="(url,index) in top_images" :key="index" class="imageItem">
          <div>
            <button @click="toBeFirst(index)">置顶</button>
          </div>
          <img :src="url" preview="6" preview-text="头图">
          <div>
            <button @click="delTopImage(index)">删除</button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <el-button @click="upToDb" type="primary">上传</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        cat_name: '',
        product_id: '',  
        title: '',
        shop_id: '',
        matchShops: [],
        coupon_val: '',  // 优惠券金额
        cover_image: '',
        top_images: [],
        catNames: ['外卖','加油','影视']
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {

      init() {
        let that = this
        let obj = that.$route.params
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: 'ProductModel'
            }
          }).then(function (res) {
            let product = res.data.data;
            console.log('product', product);
            that.product_id = product.id;
            that.title = product.title;
            that.matchShops = product.matchShops;
            that.shop_id = product.shop_id;
            that.top_images = product.top_images;
            that.cover_image = product.cover_image;
            that.coupon_val = product.coupon_val || '';
            that.cat_name = product.cat_name;
          }).catch(function (res) {
            console.log('queryAd fail', res);
            that.$message.error('查询失败, 请检查网络');
          })
        }
      },

      //上传数据库
      upToDb() {
        let that = this
        if (!that.title) {
          that.$message.error('请填写商品标题')
          return;
        }
        if (!that.shop_id) {
          that.$message.error('请选择所属店铺')
          return;
        }
        if (!that.cover_image) {
          that.$message.error('请上传封面图')
          return;
        }
        if (!that.top_images.length) {
          that.$message.error('请上传详情头图')
          return;
        }
        if (!that.cat_name) {
          that.$message.error('请选择一级类目')
          return;
        }

        let obj = {};
        if (that.product_id) {
          obj.id = that.product_id;
        }
        obj.title = that.title;
        obj.shop_id = that.shop_id;
        obj.cat_name = that.cat_name;
        obj.cover_image = that.cover_image;
        obj.top_images = that.top_images;
        obj.coupon_val = that.coupon_val || '';
        let param = {
          'db': 'ProductModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送返回', res)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传失败', res)
        })

      },

      searchShop(search) {
        let that = this;
        if (search) {
          that.$axios.get(that.$url_prefix + 'searchShop', {
            params: {
              search: search
            }
          }).then(res => {
            that.matchShops = res.data.data;
          })
        }
      },

      chooseImage(event) { // 上传图片
        let that = this
        let origin = event.target.id
        let option = {
          file: event.target.files[0],
          head_name: 'product'
        }
        that.$uploadImage(option).then(function (res) {
          console.log('upload back', res)
          if (!res) {
            console.log('upload fail')
            return false;
          }
          if (res === '图片太大') {
            that.$message.error('图片太大了');
            return false;
          }
          let img_url = res
          if (origin === 'top_images') {
            that.top_images.unshift(img_url)
          } else if (origin === 'cover_image') {
            that.cover_image = img_url
          }
          that.$previewRefresh()
        }).catch(function (res) {
          console.log('upload fail', res)
        })
      },

      delTopImage(index) {
        this.top_images.splice(index,1);
      },
      toBeFirst(index) {
        let obj = this.top_images.splice(index, 1)[0]
        this.top_images.unshift(obj)
      },

    }
  }

</script>

<style scoped>
  .product {
    text-align: center;
    overflow: hidden;
  }

  h2 {
    margin-top: 50px;
  }

  .inputBox {
    display: inline-block;
  }

  .imageBox {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
  }

  .imageBox .imageItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  .line {
    margin-top: 20px;
    color: #ccc;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

</style>



// WEBPACK FOOTER //
// src/page/Product.vue